import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const endpoints = {
  countries: () => api.get("/countries").then((r) => r.data),
  methods: () => api.get("/methods").then((r) => r.data),
  recipes: () => api.get("/recipes").then((r) => r.data),
  myRecipes: () => api.get("/recipes/mine").then((r) => r.data),
  createRecipe: (data) => api.post("/recipes", data).then((r) => r.data),
  updateRecipe: (id, data) => api.put(`/recipes/${id}`, data).then((r) => r.data),
  getRecipe: (id) => api.get(`/recipes/${id}`).then((r) => r.data),
  similarRecipes: (id) => api.get(`/recipes/${id}/similar`).then((r) => r.data),
  deleteRecipe: (id) => api.delete(`/recipes/${id}`).then((r) => r.data),
  promoteRecipe: (id) => api.post(`/recipes/${id}/promote`).then((r) => r.data),
  toggleFavorite: (id) => api.post(`/recipes/${id}/favorite`).then((r) => r.data),
  favoriteIds: () => api.get("/me/favorites").then((r) => r.data),
  favoriteRecipes: () => api.get("/recipes/favorites/list").then((r) => r.data),
  favoriteCounts: () => api.get("/recipes/favorites/counts").then((r) => r.data),
  adminCheck: () => api.get("/admin/check").then((r) => r.data),
  // Blog
  listBlogPosts: () => api.get("/blog").then((r) => r.data),
  getBlogPost: (slug) => api.get(`/blog/${slug}`).then((r) => r.data),
  createBlogPost: (data) => api.post("/blog", data).then((r) => r.data),
  updateBlogPost: (id, data) => api.put(`/blog/${id}`, data).then((r) => r.data),
  deleteBlogPost: (id) => api.delete(`/blog/${id}`).then((r) => r.data),
  calculate: (data) => api.post("/calculate", data).then((r) => r.data),
  extractionCalculate: (data) => api.post("/extraction/calculate", data).then((r) => r.data),
  extractionAiAdvice: (result) => api.post("/extraction/ai-advice", result).then((r) => r.data),
  brewLogCreate: (data) => api.post("/brew-log", data).then((r) => r.data),
  brewLogList: () => api.get("/brew-log").then((r) => r.data),
  brewLogDelete: (id) => api.delete(`/brew-log/${id}`).then((r) => r.data),
  // Weekly Brew Challenge
  getActiveChallenge: () => api.get("/challenge/active").then((r) => r.data),
  getLeaderboard: (id) => api.get(`/challenge/${id}/leaderboard`).then((r) => r.data),
  submitChallenge: (brew) => api.post("/challenge/submit", brew).then((r) => r.data),
  submitChallengeRecipe: (challengeId, data) =>
    api.post(`/challenges/${challengeId}/submit-recipe`, data).then((r) => r.data),
  getMyChallengeSubmission: (challengeId) =>
    api.get(`/challenges/${challengeId}/my-submission`).then((r) => r.data),
  setChallengeReminder: (challengeId) =>
    api.post(`/challenges/${challengeId}/remind-me`).then((r) => r.data),
  unsetChallengeReminder: (challengeId) =>
    api.delete(`/challenges/${challengeId}/remind-me`).then((r) => r.data),
  getChallengeReminder: (challengeId) =>
    api.get(`/challenges/${challengeId}/my-reminder`).then((r) => r.data),
  markProgressComplete: (contentType, contentId) =>
    api.post(`/progress/${contentType}/${contentId}/complete`).then((r) => r.data),
  listProgress: (contentType) =>
    api.get(`/progress/${contentType}`).then((r) => r.data),
  progressSummary: () =>
    api.get(`/progress/summary`).then((r) => r.data),
  progressNext: () =>
    api.get(`/progress/me/next`).then((r) => r.data),
  adminListChallenges: () => api.get("/admin/challenges").then((r) => r.data),
  adminCreateChallenge: (data) => api.post("/admin/challenges", data).then((r) => r.data),
  adminUpdateChallenge: (id, data) => api.put(`/admin/challenges/${id}`, data).then((r) => r.data),
  adminDeleteChallenge: (id) => api.delete(`/admin/challenges/${id}`).then((r) => r.data),
  // Achievements
  achievementsCatalog: () => api.get("/achievements/catalog").then((r) => r.data),
  myAchievements: () => api.get("/me/achievements").then((r) => r.data),
  // Admin – Achievements
  adminUserAchievements: (userId) => api.get(`/admin/users/${userId}/achievements`).then((r) => r.data),
  adminGrantAchievement: (user_id, key) => api.post("/admin/achievements/grant", { user_id, key }).then((r) => r.data),
  adminRevokeAchievement: (user_id, key) => api.post("/admin/achievements/revoke", { user_id, key }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
  session: (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data),
  // Activity
  trackEvent: (event) => api.post("/activity/track", event).then((r) => r.data),
  // About page
  about: () => api.get("/about").then((r) => r.data),
  adminUpdateHero: (data) => api.put("/admin/about/hero", data).then((r) => r.data),
  adminUpdateCertsPhoto: (photo) => api.put("/admin/about/certs_photo", { photo }).then((r) => r.data),
  adminAddAboutItem: (key, data) => api.post(`/admin/about/${key}`, data).then((r) => r.data),
  adminUpdateAboutItem: (key, id, data) => api.put(`/admin/about/${key}/${id}`, data).then((r) => r.data),
  adminDeleteAboutItem: (key, id) => api.delete(`/admin/about/${key}/${id}`).then((r) => r.data),
  adminReorderAbout: (key, ids) => api.put(`/admin/about-reorder/${key}`, { ids }).then((r) => r.data),
  // Academy reorder
  adminReorderTracks: (ids) => api.put("/admin/academy-reorder", { ids }).then((r) => r.data),
  adminReorderChapters: (trackId, ids) => api.put(`/admin/academy-chapters-reorder/${trackId}`, { ids }).then((r) => r.data),
  // Admin – users & analytics
  adminUsers: () => api.get("/admin/users").then((r) => r.data),
  adminUserActivity: (userId) => api.get(`/admin/users/${userId}/activity`).then((r) => r.data),
  adminStats: () => api.get("/admin/stats").then((r) => r.data),
  adminExportUsersUrl: () => `${API}/admin/users/export`,
  // Admin – CMS
  adminCreateCountry: (data) => api.post("/admin/countries", data).then((r) => r.data),
  adminUpdateCountry: (code, data) => api.put(`/admin/countries/${code}`, data).then((r) => r.data),
  adminDeleteCountry: (code) => api.delete(`/admin/countries/${code}`).then((r) => r.data),
  adminAcademy: () => api.get("/admin/academy").then((r) => r.data),
  adminAddChapter: (trackId, data) => api.post(`/admin/academy/${trackId}/chapters`, data).then((r) => r.data),
  adminUpdateChapter: (trackId, chId, data) => api.put(`/admin/academy/${trackId}/chapters/${chId}`, data).then((r) => r.data),
  adminDeleteChapter: (trackId, chId) => api.delete(`/admin/academy/${trackId}/chapters/${chId}`).then((r) => r.data),
  adminAddEncycModule: (data) => api.post(`/admin/encyclopedia/modules`, data).then((r) => r.data),
  adminUpdateEncycModule: (id, data) => api.put(`/admin/encyclopedia/modules/${id}`, data).then((r) => r.data),
  adminDeleteEncycModule: (id) => api.delete(`/admin/encyclopedia/modules/${id}`).then((r) => r.data),
  adminReorderEncyclopedia: (ids) => api.put("/admin/encyclopedia-reorder", { ids }).then((r) => r.data),
  // Academy comments
  listAcademyComments: (chapterId, sort = "new") => api.get(`/academy/comments`, { params: { ...(chapterId ? { chapter_id: chapterId } : {}), sort } }).then((r) => r.data),
  createAcademyComment: (data) => api.post("/academy/comments", data).then((r) => r.data),
  deleteAcademyComment: (id) => api.delete(`/academy/comments/${id}`).then((r) => r.data),
  adminListComments: () => api.get("/admin/academy/comments").then((r) => r.data),
  // Encyclopedia comments
  listEncyclopediaComments: (moduleId, sort = "new") => api.get(`/encyclopedia/comments`, { params: { ...(moduleId ? { module_id: moduleId } : {}), sort } }).then((r) => r.data),
  createEncyclopediaComment: (data) => api.post("/encyclopedia/comments", data).then((r) => r.data),
  deleteEncyclopediaComment: (id) => api.delete(`/encyclopedia/comments/${id}`).then((r) => r.data),
  likeEncyclopediaComment: (id) => api.post(`/encyclopedia/comments/${id}/like`).then((r) => r.data),
  adminListEncyclopediaComments: () => api.get("/admin/encyclopedia/comments").then((r) => r.data),
  // Notifications
  listNotifications: (limit = 30) => api.get("/notifications", { params: { limit } }).then((r) => r.data),
  unreadNotificationsCount: () => api.get("/notifications/unread-count").then((r) => r.data),
  markNotificationRead: (id) => api.post(`/notifications/${id}/read`).then((r) => r.data),
  markAllNotificationsRead: () => api.post("/notifications/read-all").then((r) => r.data),
  deleteNotification: (id) => api.delete(`/notifications/${id}`).then((r) => r.data),
  // Academy comment likes + sort
  likeAcademyComment: (id) => api.post(`/academy/comments/${id}/like`).then((r) => r.data),
  // Admin translate (Gemini)
  adminTranslate: (text, target = "ar") => api.post("/admin/translate", { text, target }).then((r) => r.data),
  // Admin AI suggest (Gemini) - returns {title_en, title_ar, summary_en, summary_ar}
  adminAiSuggest: (content) => api.post("/admin/ai-suggest", { content }).then((r) => r.data),
  // Admin AI generate image (Gemini Nano Banana) - returns {id, url}
  adminGenerateImage: (prompt) => api.post("/admin/generate-image", { prompt }).then((r) => r.data),
  // Admin image upload — returns {id, url}. Url should be prefixed with REACT_APP_BACKEND_URL when displayed.
  adminUploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/admin/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  // Recipe comments + ratings
  listRecipeComments: (recipeId, sort = "new") => api.get(`/recipe-comments`, { params: { recipe_id: recipeId, sort } }).then((r) => r.data),
  createRecipeComment: (data) => api.post("/recipe-comments", data).then((r) => r.data),
  deleteRecipeComment: (id) => api.delete(`/recipe-comments/${id}`).then((r) => r.data),
  likeRecipeComment: (id) => api.post(`/recipe-comments/${id}/like`).then((r) => r.data),
  getRecipeFeedback: (recipeId) => api.get(`/recipes/${recipeId}/feedback`).then((r) => r.data),
  rateRecipe: (recipeId, rating) => api.put(`/recipes/${recipeId}/rate`, { rating }).then((r) => r.data),
  unrateRecipe: (recipeId) => api.delete(`/recipes/${recipeId}/rate`).then((r) => r.data),
  // Testimonials admin
  adminClearTestimonials: () => api.delete("/admin/testimonials/all").then((r) => r.data),
  listTestimonials: () => api.get("/testimonials").then((r) => r.data),
  deleteTestimonial: (id) => api.delete(`/testimonials/${id}`).then((r) => r.data),
  // Journey CMS
  journey: () => api.get("/journey").then((r) => r.data),
  adminUpdateJourneyHead: (data) => api.put("/admin/journey/head", data).then((r) => r.data),
  adminAddJourneyStage: (data) => api.post("/admin/journey/stages", data).then((r) => r.data),
  adminUpdateJourneyStage: (id, data) => api.put(`/admin/journey/stages/${id}`, data).then((r) => r.data),
  adminDeleteJourneyStage: (id) => api.delete(`/admin/journey/stages/${id}`).then((r) => r.data),
  adminReorderJourney: (ids) => api.put("/admin/journey/reorder", { ids }).then((r) => r.data),
  // Methods CMS
  listMethods: () => api.get("/methods").then((r) => r.data),
  adminAddMethod: (data) => api.post("/admin/methods", data).then((r) => r.data),
  adminUpdateMethod: (id, data) => api.put(`/admin/methods/${id}`, data).then((r) => r.data),
  adminDeleteMethod: (id) => api.delete(`/admin/methods/${id}`).then((r) => r.data),
  adminReorderMethods: (ids) => api.put("/admin/methods-reorder", { ids }).then((r) => r.data),
  // Recipes admin
  adminListAllRecipes: () => api.get("/admin/recipes").then((r) => r.data),
  adminDeleteRecipe: (id) => api.delete(`/admin/recipes/${id}`).then((r) => r.data),
  adminSetRecipeCurated: (id, curated) => api.put(`/admin/recipes/${id}/curated`, null, { params: { curated } }).then((r) => r.data),
  // Encyclopedia public
  encyclopedia: () => api.get("/encyclopedia").then((r) => r.data),
  // Public stats (Hero counters)
  publicStats: () => api.get("/stats/public").then((r) => r.data),
  // Email broadcast
  adminEmailBroadcast: (data) => api.post("/admin/email/broadcast", data).then((r) => r.data),
  // Email diagnostics — confirms which sender + key prod is actually using
  adminEmailDiagnostics: () => api.get("/admin/email/diagnostics").then((r) => r.data),
  adminEmailDiagnosticsTestSend: (to) => api.post("/admin/email/diagnostics/test-send", { to }).then((r) => r.data),
  // Challenge presets + winner announcement
  adminApplyV60HotPreset: () => api.post("/admin/challenges/preset/v60-hot").then((r) => r.data),
  adminApplyV60IcePreset: () => api.post("/admin/challenges/preset/v60-ice").then((r) => r.data),
  adminBroadcastChallengeEmail: (challengeId) =>
    api.post(`/admin/challenges/${challengeId}/broadcast-email`).then((r) => r.data),
  adminListChallengeSubmissions: (challengeId) => api.get(`/admin/challenges/${challengeId}/submissions`).then((r) => r.data),
  adminAnnounceWinner: (challengeId, data) => api.post(`/admin/challenges/${challengeId}/announce-winner`, data).then((r) => r.data),
  // Re-engagement
  adminReengagePreview: (inactive_days = 7) => api.get(`/admin/email/reengage/preview?inactive_days=${inactive_days}`).then((r) => r.data),
  adminReengageSend: (data) => api.post("/admin/email/reengage", data).then((r) => r.data),
  // Community broadcasts wall
  listBroadcasts: () => api.get("/broadcasts").then((r) => r.data),
  communityFeed: () => api.get("/community/feed").then((r) => r.data),
  listBroadcastReplies: (id) => api.get(`/broadcasts/${id}/replies`).then((r) => r.data),
  replyToBroadcast: (id, text) => api.post(`/broadcasts/${id}/replies`, { text }).then((r) => r.data),
  deleteBroadcastReply: (broadcastId, replyId) => api.delete(`/broadcasts/${broadcastId}/replies/${replyId}`).then((r) => r.data),
  adminCreateBroadcast: (data) => api.post("/admin/broadcasts", data).then((r) => r.data),
  adminUpdateBroadcast: (id, data) => api.put(`/admin/broadcasts/${id}`, data).then((r) => r.data),
  adminDeleteBroadcast: (id) => api.delete(`/admin/broadcasts/${id}`).then((r) => r.data),
  // Yesterday's winner (Home widget)
  yesterdaysWinner: () => api.get("/challenge/yesterdays-winner").then((r) => r.data),

  // ===== My Cafe (private per-user workspace) =====
  myCafeChecklist: () => api.get("/my-cafe/checklist").then((r) => r.data),
  myCafeOverview: () => api.get("/my-cafe/overview").then((r) => r.data),
  // Branches
  myCafeBranches: () => api.get("/my-cafe/branches").then((r) => r.data),
  myCafeCreateBranch: (data) => api.post("/my-cafe/branches", data).then((r) => r.data),
  myCafeUpdateBranch: (id, data) => api.put(`/my-cafe/branches/${id}`, data).then((r) => r.data),
  myCafeDeleteBranch: (id) => api.delete(`/my-cafe/branches/${id}`).then((r) => r.data),
  // Quality Visits
  myCafeVisits: (branchId) => api.get(`/my-cafe/visits${branchId ? `?branch_id=${branchId}` : ""}`).then((r) => r.data),
  myCafeCreateVisit: (data) => api.post("/my-cafe/visits", data).then((r) => r.data),
  myCafeGetVisit: (id) => api.get(`/my-cafe/visits/${id}`).then((r) => r.data),
  myCafeUpdateVisit: (id, data) => api.put(`/my-cafe/visits/${id}`, data).then((r) => r.data),
  myCafeDeleteVisit: (id) => api.delete(`/my-cafe/visits/${id}`).then((r) => r.data),
  myCafeVisitPdfUrl: (id, lang = "en") => {
    let tz = "UTC";
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"; } catch { /* noop */ }
    return `${API}/my-cafe/visits/${id}/pdf?lang=${lang}&tz=${encodeURIComponent(tz)}`;
  },
  // Espresso
  myCafeEspresso: () => api.get("/my-cafe/espresso").then((r) => r.data),
  myCafeCreateEspresso: (data) => api.post("/my-cafe/espresso", data).then((r) => r.data),
  myCafeUpdateEspresso: (id, data) => api.put(`/my-cafe/espresso/${id}`, data).then((r) => r.data),
  myCafeDeleteEspresso: (id) => api.delete(`/my-cafe/espresso/${id}`).then((r) => r.data),
  // Drip / Coffee of the Day
  myCafeDrip: () => api.get("/my-cafe/drip").then((r) => r.data),
  myCafeCreateDrip: (data) => api.post("/my-cafe/drip", data).then((r) => r.data),
  myCafeUpdateDrip: (id, data) => api.put(`/my-cafe/drip/${id}`, data).then((r) => r.data),
  myCafeDeleteDrip: (id) => api.delete(`/my-cafe/drip/${id}`).then((r) => r.data),
  // Custom drinks
  myCafeCustom: () => api.get("/my-cafe/custom").then((r) => r.data),
  myCafeCreateCustom: (data) => api.post("/my-cafe/custom", data).then((r) => r.data),
  myCafeUpdateCustom: (id, data) => api.put(`/my-cafe/custom/${id}`, data).then((r) => r.data),
  myCafeDeleteCustom: (id) => api.delete(`/my-cafe/custom/${id}`).then((r) => r.data),
  // Team
  myCafeTeam: () => api.get("/my-cafe/team").then((r) => r.data),
  myCafeAddTeamMember: (data) => api.post("/my-cafe/team", data).then((r) => r.data),
  myCafeRemoveTeamMember: (id) => api.delete(`/my-cafe/team/${id}`).then((r) => r.data),
  myCafeSharedWithMe: () => api.get("/my-cafe/shared-with-me").then((r) => r.data),
  // Admin usage (counts only)
  myCafeAdminUsage: () => api.get("/my-cafe/admin/usage").then((r) => r.data),
};
